import { Checkbox, MenuItem } from '@mui/material';
import { Stack } from '@mui/system';
import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { TableCompHead } from '../../../../../components/ui';
import { useQuery } from '../../../../../hooks/UseQuery';
import { convToTime } from '../../../../../utils/helpers';
import CustomSelect from '../../../../../components/common/SelectField';

interface IProps {
  moduleData: any;
  isView: boolean;
  operation: string[];
  getProcess: any;
}
const tableHead: any = {
  setup: ['FRM-CMT-04', '00', '01-04-2023'],
  retro: ['', '00', '01-04-2023'],
  suspected: ['', '00', '01-04-2023'],
};

const heading: any = {
  setup: 'SETTING APPROVAL RECORDS',
  retro: 'RETROACTIVE CHECK INSPECTION RECORDS',
  suspected: 'SUSPECTED CHECK RECORDS',
};
const THeadSetup = ({ getProcess, moduleData, isView, operation }: IProps) => {
  const [render, setRender] = useState(false);
  const documentType = useQuery('documentType') || '';
  const machineName = useQuery('machine_name') || '';
  const operation_name = useQuery('operation_name') || '';
  return (
    <thead>
      <TableCompHead
        colSpan={21}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Eff. Date']}
        values={tableHead[documentType]}
        heading={'In-Process Inspection Records'}
      />
      <tr>
        <th colSpan={21} align="left">
        Operation Date:{' '}
          {isView ? (
              formatDate(moduleData.date)
            ) : (
              <DatePickerMui
                value={moment(moduleData.date || null)}
                onChange={(date) => {
                  moduleData.date = date;
                  setRender((prev) => !prev);
                }}
              />
            )}
        </th>
      </tr>
      <tr>
        <th colSpan={4} align="left">
          PART NAME:{' '}
          {moduleData.part_name
            ? moduleData.part_name
            : moduleData.part_id?.part_name}
        </th>
        <th colSpan={5} align="left">
          PART NUMBER:{' '}
          {moduleData.part_number
            ? moduleData.part_number
            : moduleData.part_id?.part_number}
        </th>
        <th colSpan={4}>
          MODEL:{' '}
          <TableInput
            name="model"
            type="text"
            value={moduleData.model}
            onChange={(e) => {
              moduleData.model = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={8} align="left">
          CUSTOMER:{' '}
          {moduleData.customer_name
            ? moduleData.customer_name
            : moduleData.customer_id?.customer_name}
        </th>
      </tr>
      <tr>
        <th colSpan={4} align="left">
        Operation Name :
        { operation_name}
        </th>
        <th colSpan={17} align="left">
          <span style={{ marginLeft: '300px' }}>TIME / OBSERVATION</span>
        </th>
      </tr>
      <tr style={{ textTransform: 'uppercase' }}>
        {[
          'S.NO.',
          'ITEM',
          'SPECIFICATION',
          'INSPECTION METHOD',
        ].map((head) => (
          <th
            rowSpan={head === 'OBSERVATION' ? 1 : 2}
            colSpan={head === 'OBSERVATION' ? 10 : 1}
            style={{ textTransform: 'uppercase' }}
          >
            {head}
          </th>
        ))}
        {[1, 2, 3, 4, 5, 6].map((head, timeHeadIdx) => (
          <>
            <th style={{ minWidth: '120px' }} colSpan={2}>
              {isView ? (
                convToTime(moduleData?.times?.[timeHeadIdx])
              ) : (
                <TimePicker
                  value={moment(
                    moduleData?.times?.[timeHeadIdx] || ''
                  )}
                  onChange={(date: any) => {
                    moduleData.times[timeHeadIdx] = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </th>
          </>
        ))}
        <th>JUDGEMENT</th>
        <th>NON CONFORMING CONSERVATION AND ACTION TAKEN (IF ANY)</th>
        <th>SIGNATURE(INSPECTOR)</th>
        <th colSpan={2}>REMARKS</th>
      </tr>
    </thead>
  );
};

export default THeadSetup;
